import React, {useEffect, useState} from "react";
import AuthenticationService from "../../../services/AuthenticationService";
import getRoutePath from "../../../routes/getRoutePath";
import {Redirect} from "react-router-dom";
import FixedLoader from "../../../components/FixedLoader";
import {
  DocumentDuplicateIcon,
  CheckCircleIcon as CheckIcon,
} from "@heroicons/react/24/outline";
import Textarea from "../../Textarea";
import {PublicPage} from "../../../components/Public";
import IconButton from "../../IconButton";
import Button from "../../Button";
import {useIntl} from "react-intl";


function useQuery() {
  return new URLSearchParams(window.location.search);
}

export default function ExternalAuth() {
  const [authenticated, setAuthentication] = useState(false);
  const [authorized, setAuthorization] = useState(true);
  const [showAccessTokenToCopy, setShowAccessTokenToCopy] = useState(false);
  const query = useQuery();
  const intl = useIntl();
  const [copied, setCopied] = useState(false);
  useEffect(() => {

    const token = query.get("access_token");
    const userData = query.get("user_data");
    const satc = query.get("show_access_token_to_copy")

    if (token && userData) {
      AuthenticationService.setAuthToken(token, JSON.parse(userData));
    } else {
      setAuthorization(false);
    }

    if (AuthenticationService.isUserAuthenticated()) {
      console.log("User authenticated with OAuth2. Back to home");
      setAuthentication(true);
    }

    if (satc) {
      setShowAccessTokenToCopy(true);
    }

  }, [authenticated, authorized, query]);



  if (authenticated) {
    if (showAccessTokenToCopy) {
      // this is not a public page, just a page to show the token code
      // and let the user copy it to the clipboard. I used the PublicPage
      // component to have the same style as the other pages and because
      // I liked the layout.
      const accessToken = AuthenticationService.getAuthToken();
      return <PublicPage showCountrySelector={false} showDeveloperLoginButton={false}>
        <div className="flex-1 flex items-center justify-center bg-white px-4 sm:px-8 py-10">
          <div className="flex flex-col w:1/2">
            <div className="flex flex-col items-center justify-center gap-4 md:py-14">
              <p className={"font-bold text-large"}>copia il codice per Completare il login</p>
              <Textarea
                value={accessToken}
                readOnly
                className="w-96 h-32"
              />
              <div className={"flex flex-row gap-x-4"}>
                <Button
                  styleType={"white"}
                  onClick={() => {
                    navigator.clipboard.writeText(accessToken);
                    setCopied(true);
                  }}
                >
                  {intl.formatMessage({id: "copy", defaultMessage: "copia"})}
                  <DocumentDuplicateIcon className="w-4 ml-2"/>
                </Button>
                {copied &&
                  <CheckIcon className="w-8 text-green-500"/>
                }
              </div>
            </div>
          </div>
        </div>
      </PublicPage>
    }
    window.location = getRoutePath("/home");
    return <div />;
  }

    if (!authorized) {
    return <Redirect to={`${getRoutePath("/login")}?unauthorized_user`}/>
  }

  return (
    <FixedLoader/>
  )
}